import { Quill } from '@vueup/vue-quill';
let Parchment = Quill.import('parchment')
class letterSpacingAttributor extends Parchment.Attributor.Style { }
const letterSpacingStyle = new letterSpacingAttributor(
  'letterSpacing',
  'letter-spacing',
  {
    scope: Parchment.Scope.INLINE,
    whitelist: [
      'initial',
      '2px',
      '4px',
      '6px',
      '8px',
      '10px',
      '12px',
      '14px',
      '16px',
    ],
  }
)
export { letterSpacingStyle };

